"use client";

import Link from "next/link";
import { useT } from "@/app/translations/useT";
import { BlogArticle } from "@/app/types/BlogArticle";
import { getCategoryLabelKey } from "../BlogCategories/BlogCategories.logic";
import { getArticleLocale, getRelatedArticles } from "./BlogArticles.logic";
import styles from "./BlogRelated.module.css";

type Props = {
  article: BlogArticle;
  lang: string;
  title: string;
};

const RELATED_COUNT = 3;

export default function BlogRelated(props: Props) {
  const T = useT();
  const { article, lang, title } = props;

  const related = getRelatedArticles(article, RELATED_COUNT);

  if (related.length === 0) {
    return null;
  }

  return (
    <section className={styles.related}>
      <h2 className={styles.title}>{title}</h2>

      <ul className={styles.list}>
        {related.map((item) => {
          const locale = getArticleLocale(item, lang);
          const categoryKey = getCategoryLabelKey(item.categoryId);

          return (
            <li key={item.key}>
              <Link href={`/${lang}/blog/${item.slug[lang]}`} className={styles.row}>
                <span className={styles.main}>
                  <span className={styles.meta}>
                    {categoryKey && (
                      <>
                        <span>{T(categoryKey)}</span>
                        <span className={styles.metaDot}>·</span>
                      </>
                    )}
                    <span>{item.readTime} min</span>
                  </span>
                  <span className={styles.name}>{locale.title}</span>
                  <span className={styles.excerpt}>{locale.excerpt}</span>
                </span>
                <span className={styles.arrow}>&rarr;</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
